import { supabase } from '@/integrations/supabase/client';

/**
 * Manages active organization in JWT for faster RLS checks
 */
export const activeOrgManager = {
  /**
   * Set active organization in user metadata
   * This updates the JWT claim for faster RLS policy checks
   */
  async setActiveOrg(orgId: string): Promise<{ success: boolean; error?: string }> {
    try {
      console.log('[ActiveOrg] Setting active org:', orgId);
      
      // First validate the org_id via RPC
      const { data: validation, error: validationError } = await supabase.rpc(
        'set_active_org',
        { org_id: orgId }
      );

      if (validationError) {
        console.error('[ActiveOrg] Validation failed:', validationError);
        return { success: false, error: validationError.message };
      }

      // Update user metadata to include active_org_id
      const { error: updateError } = await supabase.auth.updateUser({
        data: { active_org_id: orgId }
      });

      if (updateError) {
        console.error('[ActiveOrg] Failed to update user metadata:', updateError);
        return { success: false, error: updateError.message };
      }

      console.log('[ActiveOrg] Successfully set active org in JWT');
      return { success: true };
    } catch (error) {
      console.error('[ActiveOrg] Unexpected error:', error);
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Unknown error' 
      };
    }
  },

  /**
   * Get current active org from JWT
   */
  async getCurrentOrgId(): Promise<string | null> {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      return user?.user_metadata?.active_org_id || null;
    } catch (error) {
      console.error('[ActiveOrg] Failed to get current org:', error);
      return null;
    }
  }
};
